import React, { ReactNode } from 'react'

import { CircularProgress } from '@mui/material'

import style from './CircleResult.module.css'

type PropsType = {
  value: number | null
  size?: number
  children?: ReactNode
}

export const CircleResult = ({ value, size = 120, children }: PropsType) => {
  return (
    <div className={style.box} style={{ width: `${size}px` }}>
      <CircularProgress
        className={style.progress}
        variant="determinate"
        value={value || 0}
        size={size}
        thickness={5}
      />
      <CircularProgress
        className={style['progress-background']}
        variant="determinate"
        value={100}
        size={size}
        thickness={5}
      />
      {children || <span className={style.text}>{`${value || 0}%`}</span>}
    </div>
  )
}
